<button (click)="start()" [attr.disabled]="isTourReady ? null : 'true'">
  <ng-content></ng-content>
</button>
